const WORKER_URL = import.meta.env.VITE_WORKER_URL;
/** Fetch the Worker with a Shopify session token (App Bridge JWT) as Bearer auth. */
export async function apiFetch(path, init = {}) {
    if (!window.shopify || typeof window.shopify.idToken !== "function") {
        throw new Error("Shopify App Bridge unavailable — open this app from inside the Shopify admin.");
    }
    const token = await window.shopify.idToken();
    const headers = new Headers(init.headers || {});
    headers.set("authorization", `Bearer ${token}`);
    if (init.body && !headers.has("content-type"))
        headers.set("content-type", "application/json");
    return fetch(`${WORKER_URL}${path}`, { ...init, headers });
}
